var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseAccordion1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1421 5.85777C26.3316 -1.95266 13.6682 -1.95266 5.85779 5.85777C-1.95309 13.6687 -1.95265 26.3316 5.85779 34.142C13.6687 41.9529 26.3312 41.9529 34.1421 34.142C41.9525 26.3316 41.9529 13.6687 34.1421 5.85777ZM7.59771 32.4021C0.774574 25.579 0.802418 14.4487 7.62561 7.62548C14.4487 0.802345 25.5512 0.802346 32.3743 7.62548C39.1975 14.4486 39.1975 25.5511 32.3743 32.3742C25.5512 39.1973 14.4209 39.2253 7.59771 32.4021ZM27.071 25.3032L21.7677 19.9999L27.071 14.6966C27.5589 14.2087 27.5589 13.4167 27.071 12.9288C26.5831 12.4409 25.7911 12.4409 25.3032 12.9288L19.9999 18.2321L14.6966 12.9288C14.2087 12.4409 13.4168 12.4409 12.9289 12.9288C12.441 13.4167 12.441 14.2087 12.9289 14.6966L18.2322 19.9999L12.9289 25.3032C12.441 25.7911 12.441 26.5831 12.9289 27.071C13.4168 27.5589 14.2087 27.5589 14.6966 27.071L19.9999 21.7677L25.3032 27.071C25.7911 27.5589 26.5831 27.5589 27.071 27.071C27.5589 26.5831 27.5589 25.7911 27.071 25.3032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAccordion1);
export default __webpack_public_path__ + "static/media/close-accordion-1.80bf88d2eb76b97dd5f650dd1bde06c3.svg";
export { ForwardRef as ReactComponent };